const subdomainMap = new Map(
  Object.entries({
    MYGYMLadyGladbeck: 'mygym-lady',
    VitalisAmpfing: 'vitalis-ampfing',
    S5Fredersdorf: 's5-fredersdorf',
    InjoyDorsten: 'dorsten',
    fitnessmoosburg: 'fitness-moosburg',
    InjoyCottbus: 'cottbus',
    InjoyKrems: 'injoy-krems',
    MYGYMDeutschland: 'mygymde',
    INJOYXpress: 'injoy',
    ExpertenAllianz: 'expertenallianz',
    MoreFit: 'morefit',
    FitnessExpress: 'fitness-express',
  }),
);

export function getSeoTitleForSubdomain(subdomain: string): string {
  if (subdomainMap.has(subdomain)) {
    return subdomainMap.get(subdomain)!;
  }
  return subdomain;
}
